exports.formatPhone = function(phone, strict) {
  //first just read any numbers and remove any non digits until I get at least 10 digits
  let tmp = "";

  var i;
  for(i=0; i < phone.length; i++) {
    let ch=phone.charAt(i);
    if(tmp.length >= 10 && ch == ' ') {
      tmp += phone.substring(i);
      break;
    }

    if(ch >= '0' && ch <= '9') {
      tmp += ch;
    }

  }

  if(tmp.length < 10) {
    return;
  }

  if(strict && tmp.length > 10)  {
    return;
  }

  //now insert the hyphens at the proper place
  let formatted = tmp.substring(0,3) + "-" + tmp.substring(3,6) + "-" + tmp.substring(6);
  //elem.val(formatted);  //show formatted value on the screen

  return formatted;
}



// WEBPACK FOOTER //
// ./client/app/_helpers/formatUtil.js